import Select from "react-select";
import TimePicker from 'rc-time-picker';


const customStyles = {
    menuList: (provided, state) => ({
        ...provided,
        background: '#fff',
    }),
}

var dayOptionCollection = [
    {
        label: 'Sunday',
        value: 'Sun'
    },
    {
        label: 'Monday',
        value: 'Mon'
    },
    {
        label: 'Tuesday',
        value: 'Tue'
    },
    {
        label: 'Wednesday',
        value: 'Wed'
    },
    {
        label: 'Thursday',
        value: 'Thu'
    },
    {
        label: 'Friday',
        value: 'Fri'
    },
    {
        label: 'Saturday',
        value: 'Sat'
    }
];

var typeOptionCollection = [
    {
        label: 'day',
        value: 'day',
        prep: ''
    },
    {
        label: 'work day',
        value: 'workday',
        prep: ''
    },
    {
        label: 'week',
        value: 'week',
        prep: ''
    },
    {
        label: 'month',
        value: 'month',
        prep: ''
    }
];

var firstMonthOptionCollection = [
    {
        label: 'date of the',
        value: 'any'
    },
    {
        label: 'first',
        value: '1'
    },
    {
        label: 'second',
        value: '2'
    }, {
        label: 'third',
        value: '3'
    }, {
        label: 'fourth',
        value: '4'
    }, {
        label: 'fifth',
        value: '5'
    },
    {
        label: 'last',
        value: 'last'
    }
];

function ordinalSuffix(n) {
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const val = n % 100;

    return `${n}${suffixes[(val - 20) % 10] || suffixes[val] || suffixes[0]}`;
}

function getRange(n) {
    return [...Array(n).keys()];
}

function getMonthDaysOptions() {
    return getRange(31).map((v) => {
        return {
            label: ordinalSuffix(v + 1),
            value: v + 1
        };
    });
}

export class ScheduleSelector extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            type: null,
            day: null,
            monthType: null
        }
    }

    handleChange(key, selectedOption) {
        var newState = {}
        newState[key] = selectedOption;
        this.setState(newState, () => {
            if (this.props.onChange) {
                this.props.onChange(this.getCron());
            }
        });

        
    }

    renderMonthSelector() {
        var secondOption = <Select className="select-inline type-month"
                                   styles={customStyles}
                               value={this.state.monthDay}
                               onChange={this.handleChange.bind(this, 'monthDay')}
                               options={dayOptionCollection}/>;

        if (this.state.monthType == null || this.state.monthType.value == 'any') {
            secondOption = <Select
                className="select-inline type-month"
                               styles={customStyles}
                               value={this.state.monthDays}
                               isMulti
                               onChange={this.handleChange.bind(this, 'monthDays')}
                               options={getMonthDaysOptions()}/>;
        }

        return <span>on the
                   <Select
                className="select-inline type-week"
                       styles={customStyles}
                       value={this.state.monthType}
                       onChange={this.handleChange.bind(this, 'monthType')}
                       options={firstMonthOptionCollection} /> {secondOption} at <TimePicker
                                                                                     value={this.state.time}
                                                                                    onChange={this.handleChange.bind(this, 'time')}
                                                                                     showSecond={false}
                                                                                     use12Hours
                                                                                     inputReadOnly
                                                                                 />
               </span>;
    }

    renderWeekSelector() {
        return <span>on <Select
            className="select-inline type-week"
                            styles={customStyles}
                            value={this.state.day}
                            isMulti
                            onChange={this.handleChange.bind(this, 'day')}
                            options={dayOptionCollection}
        /> at <TimePicker
                  value={this.state.time}
                  onChange={this.handleChange.bind(this, 'time')}
                  showSecond={false}
                  use12Hours
                  inputReadOnly
              /></span>;
    }
    
    renderDaySelector() {
        return <span>at <TimePicker
                            value={this.state.time}
                            onChange={this.handleChange.bind(this, 'time')}
                            showSecond={false}
                            use12Hours
                            inputReadOnly
                        /></span>;
    }

    renderType() {
        if (this.state.type != null) {
            switch (this.state.type.value) {
                case 'workday':
                case 'day':
                    return this.renderDaySelector();

                case 'week':
                    return this.renderWeekSelector();

                case 'month':
                    return this.renderMonthSelector();
            }
        }
    }

    getCronDay() {
        return this.state.day.map((obj) => {
            return obj.value;
        });
    }

    getCronDate() {
        return this.state.monthDays.map((obj) => {
            return obj.value;
        });
    }


    getCronMonthDay() {
        if (this.state.monthType.value == 'last') {
            return this.state.monthDay.value + "L";
        }

        return `${this.state.monthDay.value}#${this.state.monthType.value}`;
    }

    getCron() {
        if (this.state.time == null) {
            return;
        }

        if (this.state.type != null) {
            switch (this.state.type.value) {
                case 'workday':
                    return `0 ${this.state.time.format('mm')} ${this.state.time.format('HH')} ? * MON-FRI *`;

                case 'day':
                    return `0 ${this.state.time.format('mm')} ${this.state.time.format('HH')} ? * * *`;

                case 'week':
                    if (this.state.day == null) {
                        return;
                    }
                    return `0 ${this.state.time.format('mm')} ${this.state.time.format('HH')} ? * ${this.getCronDay()} *`;

                case 'month':
                    if (this.state.monthType == null) {
                        return;
                    }

                    if (this.state.monthType.value == 'any') {
                        if (this.state.monthDays == null) {
                            return;
                        }

                        return `0 ${this.state.time.format('mm')} ${this.state.time.format('HH')} ${this.getCronDate()} * ? *`;
                    } else {
                        if (this.state.monthDay == null ) {
                            return;
                        }

                        return `0 ${this.state.time.format('mm')} ${this.state.time.format('HH')} ? * ${this.getCronMonthDay()} *`;
                    }
                    
            }
        }
    }

    render() {
        return (
            <div className="schedule-selector">
                <div>
                    <div>
                        Every

                        <Select 
                            className="select-inline type-select"
                            value={this.state.type}
                            styles={customStyles}
                            onChange={this.handleChange.bind(this, 'type')}
                            options={typeOptionCollection}
                        />

                        {this.renderType()}
                        
                    </div>
                </div>
            </div>
        );
    }
}